import React, { useState } from "react";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import { FaHandSparkles } from "react-icons/fa";
import {
  FiImage,
  FiPhone,
  FiShare2,
  FiMapPin,
  FiSettings,
  FiAlignLeft,
  FiCalendar,
  FiDollarSign,
  FiMoon,
} from "react-icons/fi";

const slugify = (str = "") =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");

const dayOptions = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [fee, setFee] = useState<any>(0);
  const [vip, setVip] = useState<any>(0);
  const [vvip, setVvip] = useState<any>(0);

  const [email, setEmail] = useState("");
  const [payLink, setPayLink] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");

  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState("");

  const [featured, setFeatured] = useState<any>("no");
  const [promoted, setPromoted] = useState<any>("no");
  const [nightlifeStatus, setNightlifeStatus] = useState(1);
  const [expo, setExpo] = useState(0);
  const [pricing, setPricing] = useState<any[]>([]);

  const [description, setDescription] = useState("");
  const [repeatEvery, setRepeatEvery] = useState("");
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  const nightlifeRoutes = "/data/nightlife";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const clearForm = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(defaultImage);
    setThumbnailId("img_cdn_id");
    setTitle("");
    setVenue("");
    setStartDate("");
    setEndDate("");
    setStartTime("");
    setEndTime("");
    setFee(0);
    setVip(0);
    setVvip(0);
    setExpo(0);
    setEmail("");
    setPayLink(null);
    setPhoneNumber("");
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress("");
    setFeatured("no");
    setPromoted("no");
    setDescription("");
    setRepeatEvery("");
    setPricing([]);
  };

  const toggleRepeat = (val: string) => {
    const parts = repeatEvery ? repeatEvery.split("|").filter(Boolean) : [];
    if (parts.includes(val)) {
      const next = parts.filter((d: string) => d !== val).join("|");
      setRepeatEvery(next);
    } else {
      const next = [...parts, val].join("|");
      setRepeatEvery(next);
    }
  };

  const isDaySelected = (val: string) =>
    (repeatEvery || "").toString().split("|").includes(val);

  const addOneNightlifeHandler = async (e: any) => {
    e.preventDefault();

    if (!thumbnail || !thumbnailId) {
      responses(true, "Profile image is required.");
      return;
    }
    if (!title) {
      responses(true, "Title is required.");
      return;
    }
    if (startDate && endDate) {
      const sd = new Date(`${startDate}T${startTime || "00:00"}`);
      const ed = new Date(`${endDate}T${endTime || "23:59"}`);
      if (sd > ed) {
        responses(true, "Start date/time must be before end date/time.");
        return;
      }
    }

    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id,
      first_level_id: first_level_id || 0,
      second_level_id: second_level_id || 0,
      third_level_id: third_level_id || 0,
      fourth_level_id: fourth_level_id || 0,
      title,
      slug: title ? slugify(title) : null,
      description,
      venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      fee,
      vip,
      vvip,
      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",
      phone_number: phoneNumber || null,
      email_address: email || null,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: `${tags || ""}${tags ? ", " : ""}${hashtags || ""}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress || null,
      country_short: "none",
      status: nightlifeStatus,
      featured,
      promoted,
      repeat_every: repeatEvery,
      expo,
      pricing,
    };

    const { status, message } = await createOneContent({
      data,
      content: _TYPES_.NIGHTLIFE,
    });

    if (status === 200 || status === 201) {
      clearForm();
      responses(false, message || "Nightlife added.");
    } else {
      responses(true, message || "Failed to add nightlife.");
    }
  };

  return (
    <AddPageShell
      backRoute={nightlifeRoutes}
      eyebrow="DoSee Data • Nightlife"
      title="Add Nightlife"
      subtitle={`Curate after-dark spots in ${entry_label || "this destination"}.`}
      icon={<FiMoon className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Add Nightlife"
      onSubmit={addOneNightlifeHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero shot travellers see first."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.NIGHTLIFE)}
        />
      </AddSection>

      <AddSection title="Basics" hint="Name, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title,
              onChange: (e: any) => {
                setTitle(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue,
              onChange: (e: any) => {
                setVenue(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress,
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Optional schedule and recurring days."
        icon={<FiCalendar className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate,
              onChange: (e: any) => {
                setStartDate(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate,
              onChange: (e: any) => {
                setEndDate(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime,
              onChange: (e: any) => {
                setStartTime(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime,
              onChange: (e: any) => {
                setEndTime(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
        <div className="mt-5">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Repeat Every
          </p>
          <div className="flex flex-wrap gap-3">
            {dayOptions.map((val) => (
              <button
                key={val}
                type="button"
                onClick={() => toggleRepeat(val)}
                className={[
                  "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium capitalize transition",
                  isDaySelected(val)
                    ? "border-brand bg-brand/10 text-brand"
                    : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50",
                ].join(" ")}
              >
                {isDaySelected(val) ? (
                  <MdCheckBox className="h-4 w-4" />
                ) : (
                  <MdCheckBoxOutlineBlank className="h-4 w-4" />
                )}
                {val}
              </button>
            ))}
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Quick fees plus full pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <InputField
            props={{
              id: "fee",
              title: "Entry Fee",
              type: "number",
              value: fee,
              onChange: (e: any) => {
                setFee(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "vip",
              title: "VIP Fee",
              type: "number",
              value: vip,
              onChange: (e: any) => {
                setVip(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "vvip",
              title: "VVIP Fee",
              type: "number",
              value: vvip,
              onChange: (e: any) => {
                setVvip(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
        <div className="mt-5">
          <Pricing pricing={pricing} setPricing={setPricing} />
        </div>
      </AddSection>

      <AddSection
        title="Contact"
        hint="How travellers can get in touch."
        icon={<FiPhone className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <PhoneInput
            setPhone={setPhoneNumber}
            phone={phoneNumber}
            required={false}
          />
          <InputField
            props={{
              id: "email",
              title: "Email Address",
              type: "email",
              value: email,
              onChange: (e: any) => {
                setEmail(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "pay-link",
              title: "Pay Link (Optional)",
              type: "text",
              value: payLink || "",
              onChange: (e: any) => {
                setPayLink(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Social"
        hint="Optional public handles."
        icon={<FiShare2 className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          <InputField
            props={{
              id: "whatsapp",
              title: "Whatsapp",
              type: "text",
              value: whatsapp,
              onChange: (e: any) => {
                setWhatsapp(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "facebook",
              title: "Facebook",
              type: "text",
              value: facebook,
              onChange: (e: any) => {
                setFacebook(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "twitter",
              title: "Twitter",
              type: "text",
              value: twitter,
              onChange: (e: any) => {
                setTwitter(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "instagram",
              title: "Instagram",
              type: "text",
              value: instagram,
              onChange: (e: any) => {
                setInstagram(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "youtube",
              title: "YouTube",
              type: "text",
              value: youtube,
              onChange: (e: any) => {
                setYoutube(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Geo Position"
        hint="Latitude, longitude and embed code."
        icon={<FiMapPin className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "google_map_code",
              title: "Google Map Code",
              type: "text",
              value: googleMapCode,
              onChange: (e: any) => {
                setGoogleMapCode(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "latitude",
              title: "Latitude",
              type: "text",
              value: latitude,
              onChange: (e: any) => {
                setLatitude(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "longitude",
              title: "Longitude",
              type: "text",
              value: longitude,
              onChange: (e: any) => {
                setLongitude(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Visibility"
        hint="Control how this entry appears on the site."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
          <Select
            props={{
              id: "nightlife_status",
              title: "Status",
              option: ["visible", "invisible"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setNightlifeStatus(1);
                else setNightlifeStatus(0);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "featured",
              title: "Featured",
              option: ["no", "yes"],
              onChange: (e: any) => {
                setFeatured(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              onChange: (e: any) => {
                setPromoted(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Description"
        hint="Vibe, dress code, music style — whatever travellers should know."
        icon={<FiAlignLeft className="h-4 w-4" />}
        actions={
          <MyButton
            onClick={() => setShowDescriptionModal(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          >
            <FaHandSparkles className="h-4 w-4" />
            Generate
          </MyButton>
        }
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description,
            onChange: (e: any) => {
              setDescription(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
        <div className="mt-4">
          <InputField
            props={{
              id: "hashtag",
              title: "Tags (comma separated)",
              type: "text",
              value: hashtags,
              onChange: (e: any) => {
                setHashtags(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
